module.exports = __webpack_public_path__ + "static/media/Era.f65b2fe3.md";